module.exports = __webpack_public_path__ + "img/progress-task-bottom.5dda344b.png";